import React from 'react';
import AlignedImg from 'components/AlignedImg';
import ReverseLogo from './apex-logo-reverse.svg';
import styles from './styles.css';

const CenteredAppHeader = () => (
  <div className={styles.header}>
    <AlignedImg
      align="center"
      src={ReverseLogo}
      alt="Apex Clearing"
      width="254"
      style={{ cursor: 'pointer' }}
    />
  </div>
);

export default CenteredAppHeader;



// WEBPACK FOOTER //
// ./src/components/CenteredAppHeader/index.js